import {Fragment} from "react";
import {Table, Flex, NumberInput} from "@chakra-ui/react";
import {useCalculator} from "../context/calculatorContext/context";

const TableBody = (props) => {
  const {tableBodyData} = props;
  const {quantityChangeFunction} = useCalculator();

  return (
    <Fragment>
      {tableBodyData?.length > 0 && (
        <Table.Body>
          {tableBodyData.map((item) => {
            const {name, cpu, ram, id, quantity} = item;

            return (
              <Table.Row key={id}>
                <Table.Cell data-cy="name-column" textAlign={"center"}>
                  {name}
                </Table.Cell>
                <Table.Cell data-cy="cpu-column" textAlign={"center"}>
                  {cpu}
                </Table.Cell>
                <Table.Cell data-cy="ram-column" textAlign={"center"}>
                  {ram >= 1024 ? ram / 1024 + " GB" : ram + " MB"}
                </Table.Cell>
                <Table.Cell data-cy="quantity-column">
                  <Flex alignItems={"center"} justifyContent={"center"}>
                    <NumberInput.Root
                      size="sm"
                      maxW={24}
                      min={0}
                      value={quantity}
                      onValueChange={({value}) => {
                        let n = Math.floor(Number(value));
                        if (n !== Infinity && n >= 0 && n !== quantity) {
                          quantityChangeFunction(n, id);
                        }
                      }}
                      data-cy="table-quantity-input"
                    >
                      <NumberInput.Control />
                      <NumberInput.Input />
                    </NumberInput.Root>
                  </Flex>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      )}
    </Fragment>
  );
};

export default TableBody;
